import { forwardRef } from "react";

const FileReport = forwardRef(
    ({ visible, archivosFaltantes, todosEncontrados, mensaje, isDownloading = false }, ref) => {
        if (!visible) return null;

        return (
            <div ref={ref}>
                {visible && (
                    <div id="file-report" className="mt-3 p-3 border rounded bg-light">
                        <strong className="titles-form" id="title-file-report">
                            {mensaje}
                        </strong>
                        {todosEncontrados ? (
                            <p id="yes-file" className="mt-2 text-success fw-bold">
                                {isDownloading
                                    ? "Todos los archivos se encuentran en el servidor. Descargando archivos..."
                                    : "Todos los archivos se encuentran disponibles en el servidor."}
                            </p>
                        ) : (
                            archivosFaltantes.length > 0 && (
                                <>
                                    <p id="no-file" className="mt-2 fw-bold">
                                        Archivos no encontrados ({archivosFaltantes.length}):
                                    </p>
                                    <ol id="myList" style={{ maxHeight: "300px", overflowY: "auto" }}>
                                        {archivosFaltantes.map((nameF, index) => (
                                            <li key={index}>{nameF}</li>
                                        ))}
                                    </ol>
                                </>
                            )
                        )}
                    </div>
                )}
            </div>
        );
    }
);

export default FileReport;
